import React from 'react'
import { useContext } from '../Context'
import { useConfirmDialog } from '@ztechapps/common.hook'
import { ShowIf } from '@ztechapps/webui.util'
import { useRemoveToCart } from '@ztechapps/order.common'
import { BusyButton } from '@ztechapps/webui.button'

export const RemoveItem = ({ itemId }: { itemId: string }) => {
  const { document, canEdit } = useContext()
  const orderId = document?._id

  const { removeToCart, loading, error } = useRemoveToCart()
  const { setShowLoadingOverlay } = useContext()

  const { confirm } = useConfirmDialog({ title: 'Remove from cart?', text: 'Item(s) will be removed from the order.' })

  const onClick = async () => {
    if (loading) return
    await confirm(async () => {
      setShowLoadingOverlay(true)
      try {
        await removeToCart({ itemId, orderId })
      } finally {
        setShowLoadingOverlay(false)
      }
    })
  }

  return (
    <ShowIf condition={canEdit}>
      <BusyButton
        type="button"
        bsStyle="danger"
        title="Remove item"
        icon="trash"
        disabled={loading || !!error}
        onClick={onClick}
      />
    </ShowIf>
  )
}
